module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_3016.2a3812f6.png";